import api from "../services/api";

const path = "localizacaopontoacesso";

export const getLocalizationsPointAccess = async () => {
  return await api.get(`${path}`);
};

export const findLocalizationPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editLocalizationPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createLocalizationPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteLocalizationPointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
